export default __webpack_public_path__ + "static/media/pic3.2d7c37d6.jpg";